export const baseUrl = 'https://baldwin-school-backend.vercel.app/api'
// export const baseUrl = 'http://localhost:8080/api'